require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wob-self-led-series-session-1.json") })
        }
      }, "path---wob-self-led-series-session-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wob-self-led-series-session-1!./.cache/json/wob-self-led-series-session-1.json
// module id = 1249
// module chunks = 231608221292675